module.exports = __webpack_public_path__ + "img/polygon_large.8b64d59b.svg";